import { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { MoovyProgress } from '../components'
import { appRoutes } from './permissions'

type MoovyRouteProps = {
  isProgress?: boolean
  isAllowed?: boolean
  path?: string
  redirectPath?: string
  loginPath?: string
  children?: ReactNode
}

const MoovyRoute = ({
  isProgress = false,
  isAllowed = true,
  redirectPath = appRoutes.ROOT,
  children,
}: MoovyRouteProps) => {
  if (isProgress) {
    return <MoovyProgress />
  }

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />
  }

  return children ? children : <Outlet />
}

export default MoovyRoute
